import { Injectable } from "@angular/core";
import { CanActivate, Router } from "@angular/router";

@Injectable({
    providedIn: 'root'
})
export class HomeStepGuard implements CanActivate {

    constructor(private router: Router) { }

    canActivate(): boolean {
        let homeCareData: any = localStorage.getItem('homecare')
        //  const homeCare = localStorage.getItem('HomeCareRole')
        let Details = JSON.parse(homeCareData);
        console.log("Details ", Details);
        if ((Details.role === 'home-care-manager' || Details.role === 'home-care-vendor') && (Details.step === 3 || Details.step === 4)) {
            return true;
        }
        return false;
    }
}